import { EditorState } from "prosemirror-state";

export enum MentionInputStateKind {
	Unknown = 0,
	ProseMirror = 1
}

type UnknownMentionInputState = {
	kind: MentionInputStateKind.Unknown;
};

export type ProseMirrorMentionInputState = {
	kind: MentionInputStateKind.ProseMirror;
	editorState: EditorState;
};

export type MentionInputState =
	| UnknownMentionInputState
	| ProseMirrorMentionInputState;

export function isProseMirror(state: MentionInputState): state is ProseMirrorMentionInputState {
	return state.kind === MentionInputStateKind.ProseMirror;
}